import {Component, Inject} from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {EFilterType, ICellConfig} from "../../../interface/table.config";
import {MatIcon} from "@angular/material/icon";
import {NgForOf, NgIf} from "@angular/common";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";

@Component({
  selector: 'app-base-edit-filter',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    NgIf,
    MatOption,
    NgForOf,
    MatSelect,
  ],
  templateUrl: './base-edit-filter.component.html',
  styleUrl: './base-edit-filter.component.scss'
})
export class BaseEditFilterComponent {
  value: any = null;

  constructor(
    public dialogRef: MatDialogRef<BaseEditFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {field: string, curVal: any, config: ICellConfig},
  ) {
    this.value = this.data.curVal;
  }

  onSubmit() {
    this.dialogRef.close({value: this.value, field: this.data.field});
  }

  protected readonly EFilterType = EFilterType;
}
